import { PartitionMethod, Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from '../../expression.util';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { Owned } from 'shell-models-lib';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { PartitionPlainObject } from 'worker/app-workers/shared/plainObjects/partition.plainObject';
import { IntegerDataFlowType } from 'app/model/dataflow/dataflow-datatype';

export class PartitionConvertor {
    public static convertFromPlainObject(partitionObject: PartitionPlainObject, transformation: Transformation): Transformation {
        if (partitionObject) {
            transformation.partitionMethod = partitionObject.partitionMethod as PartitionMethod;
            if (transformation.partitionMethod !== 'key') {
                transformation.numberOfPartitions = DataFlowExpressionUtils.unwrapExpressionConfigValue(partitionObject.numberOfPartitions, transformation, IntegerDataFlowType.TYPE);
                // If we have an expression, or our number of partitions is > 1, then it is partitioned
                const isPartitioned = transformation.numberOfPartitions.templateExpression || parseInt(transformation.numberOfPartitions.expression, 10) > 1;
                transformation.partitionOption = isPartitioned
                    || (transformation instanceof DataFlowSource && transformation.partitionPredicates.length) ? 'Partitioning' : 'NoPartition';
            } else {
                transformation.numberOfPartitions.expression = '0';
                transformation.partitionOption = 'Partitioning';
            }
            transformation.partitionConditions = [];
            partitionObject.conditions.forEach((condition) => {
                const conditionExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, transformation);
                conditionExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(condition);
                transformation.partitionConditions.push(conditionExpression);
            });
        }

        return transformation;
    }
}
